import React from 'react'
import { TSearchType } from 'src/shared/types'
import { ItemData } from 'src/context/results/types'
import { GetProvidersFilter } from 'src/api/types'

import { TResultListItemProps } from './types'
import { FacilityResultListItem } from './FacilityResultListItem'
import { PractitionerResultListItem } from './PractitionerResultListItem'
import { ProviderResultListItem } from './ProviderResultListItem'

interface ListItemProps<T extends TSearchType> extends TResultListItemProps {
  data: ItemData
  type?: T
  onClickExpand: T extends 'practice' ? (id: string | null) => void : never
  id: T extends 'practice' ? string : string | undefined
  filterOptions: GetProvidersFilter
  specialtyCode?: string
  style?: React.CSSProperties
  onExtend?(): void
  togglePopup(pin: string): void
  isOpen?: boolean
}

export const ListItem = React.forwardRef<
  HTMLDivElement,
  ListItemProps<TSearchType>
>(
  <T extends TSearchType>(
    { type, data, onExtend, ...props }: ListItemProps<T>,
    ref: React.Ref<HTMLDivElement>
  ) => {
    switch (type) {
      case 'facility':
        return (
          <FacilityResultListItem
            ref={ref}
            {...(props as ListItemProps<'facility'>)}
            {...data}
          />
        )
      case 'practitioner':
        return (
          <PractitionerResultListItem
            ref={ref}
            {...(props as ListItemProps<'practitioner'>)}
            {...data}
          />
        )
      default:
        return (
          <ProviderResultListItem
            onExtend={onExtend}
            ref={ref}
            {...(props as Omit<ListItemProps<'practice'>, 'data' | 'type'>)}
            {...data}
          />
        )
    }
  }
)
